export default class UnauthorizedError extends Error {
  constructor() {
    super();
    this.name = 'UnauthorizedError';
    this.message = 'Usuário não tem permissão para realizar esta ação';
  }
}
